import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 2L4.00002 2C2.89546 2 2.00003 2.89543 2.00003 4L2 12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2ZM4.00003 3.33334L12 3.33333C12.3682 3.33333 12.6667 3.63181 12.6667 4V8H10.5827C10.2785 8 10.0128 8.20591 9.93703 8.5005C9.71497 9.36325 8.931 10 8 10C7.06899 10 6.28503 9.36325 6.06297 8.5005C5.98714 8.20591 5.72153 8 5.41734 8H3.33335L3.33336 4C3.33336 3.63181 3.63184 3.33334 4.00003 3.33334Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }